// extracted by mini-css-extract-plugin
export default {"container":"_W1Z_I","text":"DkgKLs","block":"HbNKgX","glitch-before":"urWvYQ","glitchBefore":"urWvYQ","glitch-after":"_YgVZf","glitchAfter":"_YgVZf"};